@if (showMarketHelp()) {
    <ms-market-help [optionGroup]="optionGroup()" [eventHelpText]="eventHelpText()" />
}
@if (isShowTabs() && tabs.length) {
    <ds-tabs-group indicator="underline" size="small" [scrollable]="true">
        <ds-tab [name]="tabs[0].title ?? ''" [title]="tabs[0].title ?? ''" />
        <ds-divider />
    </ds-tabs-group>
}
@if (isTeamGroupingEnabled()) {
    <ms-team-grouping-tab-bar [event]="event()" [optionGroup]="optionGroup()" (teamGroupingChange)="onTeamGroupingChange($event)" />
}
<div class="option-group-container player-milestone-container" [ngClass]="isOptionGroupHasTwoOptions() ? 'triple' : 'double'">
    @if (isOverUnder) {
        <div class="option-group-header player-milestone-over-under">
            <span>{{ optionGroup().parameterTranslations?.columnOver }}</span>
            <span>{{ optionGroup().parameterTranslations?.columnUnder }}</span>
        </div>
    } @else {
        <ng-container *msShowInEpcot="false">
            <div class="option-group-header player-milestone-options">
                <span>{{ optionGroup().parameterTranslations?.columnYes }}</span>
                @if (isOptionGroupHasTwoOptions()) {
                    <span>{{ optionGroup().parameterTranslations?.columnNo }}</span>
                }
            </div>
        </ng-container>
    }

    @for (group of optionGroups() | slice: 0 : visibleOptionsLimit(); track group.optionGroupId) {
        <div class="attribute-key" [class.option-name-stats-container]="showPlayerStats()">
            @if (isShowHeadshotImage()) {
                <ms-participant-image
                    class="participant-logo"
                    [participantImage]="group.options[0]?.image ?? group.options[1]?.image"
                    [showLogoColor]="true"
                    [participantType]="participantType.Player"
                    [sportId]="event().sport.id" />
            }
            <div>
                <span class="title">{{ group.attribute }}</span>
                @if (isCrmMarketPromoted(group)) {
                    <ms-promotion-badge class="no-title" />
                }
                @if (showPlayerStats()) {
                    @let eventValue = event();
                    @let optionValue = optionGroup();
                    @if (eventValue.playerStats && optionValue.detailedGrouping.playerStatsProps) {
                        <ms-player-stats
                            [playerStats]="eventValue.playerStats"
                            [sportId]="eventValue.sport.id"
                            [playerStatsProps]="optionValue.detailedGrouping.playerStatsProps"
                            [playerIds]="getPlayers(group)"
                            [source]="optionGroup().source" />
                    }
                }
            </div>
        </div>
        @for (option of group.options; track option.id) {
            <ms-option
                [option]="option"
                [tracking]="{ source: tracking(), moduleType: trackingModuleType() }"
                [optionGroup]="optionGroup()"
                [event]="event()"
                [showPromoBadge]="!!crmPromoIdsMap().options[option.id]"
                [sourceOfPick]="sourceOfPick()"
                [betDetails]="betDetails()" />
        }
    }
</div>

@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData()" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}
